import { useEffect, useState } from "react";
import { useSearchParams } from "react-router";

export const useSearchParamState = <T extends string>(
  parameterKey: string,
  defaultValue?: T,
): [T, (parameterValue: T) => void] => {
  const [searchParams, setSearchParams] = useSearchParams();

  const [paramValue, setParameterValue] = useState(
    searchParams.get(parameterKey) ?? defaultValue ?? "",
  );

  useEffect(() => {
    setSearchParams((currentSearchParams) => {
      const newSearchParams = new URLSearchParams(currentSearchParams);
      if (paramValue) newSearchParams.set(parameterKey, paramValue);
      else newSearchParams.delete(parameterKey);
      return newSearchParams;
    });
  }, [paramValue, setSearchParams, parameterKey]);

  return [paramValue as T, setParameterValue];
};
